var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgESprawozdaniaStartPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Grafika") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333333,32 L10.6666667,32 L10.6666667,106.666667 C10.6666667,112.533333 15.4666667,117.333333 21.3333333,117.333333 L96,117.333333 L96,106.666667 L21.3333333,106.666667 L21.3333333,32 Z M106.666667,10.6666667 L42.6666667,10.6666667 C36.8,10.6666667 32,15.4666667 32,21.3333333 L32,85.3333333 C32,91.2 36.8,96 42.6666667,96 L106.666667,96 C112.533333,96 117.333333,91.2 117.333333,85.3333333 L117.333333,21.3333333 C117.333333,15.4666667 112.533333,10.6666667 106.666667,10.6666667 Z M101.333333,58.6666667 L48,58.6666667 L48,48 L101.333333,48 L101.333333,58.6666667 Z M80,80 L48,80 L48,69.3333333 L80,69.3333333 L80,80 Z M101.333333,37.3333333 L48,37.3333333 L48,26.6666667 L101.333333,26.6666667 L101.333333,37.3333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2.0-E-SPRAWOZDANIE---START",
    transform: "translate(-601.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Szambelan",
    transform: "translate(428.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grafika",
    transform: "translate(177.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 116,
    cy: 116,
    r: 116
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,232 C180.065031,232 232,180.065031 232,116 C232,51.934969 180.065031,0 116,0 C51.934969,0 0,51.934969 0,116",
    id: "Oval",
    stroke: "#979797",
    strokeWidth: 8,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(116.000000, 116.000000) rotate(90.000000) translate(-116.000000, -116.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Library-books",
    opacity: 0.384347098,
    transform: "translate(52.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Black-38%",
    mask: "url(#mask-2)",
    fill: "#000000",
    fillOpacity: 0.38,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESprawozdaniaStartPage);
export default __webpack_public_path__ + "static/media/eSprawozdania_StartPage.ddf90e3c235d11ff847140bcc6b05330.svg";
export { ForwardRef as ReactComponent };